import React from 'react';
import { Briefcase, BarChart2, FileText, Shield } from 'lucide-react';
import LoginForm from './auth/LoginForm';

export default function Login() {
  return (
    <div className="min-h-screen bg-white flex">
      {/* Left Side */}
      <div className="flex-1 flex flex-col justify-center px-12 lg:px-24">
        <div className="mb-12">
          <div className="inline-flex items-center px-3 py-2 bg-blue-50 rounded-lg">
            <Briefcase className="w-5 h-5 text-blue-600 mr-2" />
            <span className="text-blue-700 font-medium">M&A Suite</span>
          </div>
        </div>

        <h1 className="text-5xl font-bold text-gray-900 mb-6">
          Enterprise M&A<br />Management Platform
        </h1>
        
        <p className="text-xl text-gray-600 mb-12">
          Streamline your M&A process with advanced deal management,<br />
          due diligence, and post-merger integration tools.
        </p>

        <div className="grid grid-cols-2 gap-6 mb-12">
          <div className="p-6 bg-white border border-gray-100 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                <BarChart2 className="w-5 h-5 text-blue-600" />
              </div>
              <h3 className="ml-3 font-semibold text-gray-900">Deal Analytics</h3>
            </div>
            <p className="text-gray-600">
              Advanced financial modeling, valuation tools, and synergy analysis
            </p>
          </div>

          <div className="p-6 bg-white border border-gray-100 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center">
                <FileText className="w-5 h-5 text-blue-600" />
              </div>
              <h3 className="ml-3 font-semibold text-gray-900">Virtual Data Room</h3>
            </div>
            <p className="text-gray-600">
              Secure document management and due diligence tracking
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-8">
          <div className="flex items-center">
            <Shield className="w-5 h-5 text-green-500 mr-2" />
            <span className="text-gray-600">SOC 2 Type II Certified</span>
          </div>
          <div className="flex items-center">
            <Shield className="w-5 h-5 text-green-500 mr-2" />
            <span className="text-gray-600">Bank-Level Encryption</span>
          </div>
          <div className="flex items-center">
            <Shield className="w-5 h-5 text-green-500 mr-2" />
            <span className="text-gray-600">GDPR Compliant</span>
          </div>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="hidden lg:flex lg:w-[480px] bg-gray-50 items-center justify-center">
        <div className="w-full max-w-sm p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Sign in to your workspace</h2>
          <LoginForm />
        </div>
      </div>
    </div>
  );
}